// extracted by mini-css-extract-plugin
export default {"searchInput":"vx3f61SC_UZpBdnouzqj__searchInput___","simplePadding":"E4n11g9Sf773YTn6aefu__simplePadding___"};